import { createContext, createRef, useContext } from 'react';
export var SummaryContext = createContext({
  sticky: false,
  stickyTops: [],
  symbolList: [],
  stickyStartList: [],
  stickyEndList: [],
  whitespaceGrid: [],
  widthList: []
});
export var useSummaryContext = function useSummaryContext() {
  return useContext(SummaryContext);
};
var previousColIndexRef = createRef();
previousColIndexRef.current = -1;
export var SummaryRowContext = createContext({
  stickyTop: 0,
  rowIndex: 0,
  previousColIndexRef: previousColIndexRef
});
export var useSummaryRowContext = function useSummaryRowContext() {
  return useContext(SummaryRowContext);
};